import * as React from "react"
const SeriesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M5 1.5h12M3 4.5h16"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M6.6 7.5h8.8c3.67 0 5.1 1.43 5.1 5.1v3.3c0 3.67-1.43 5.1-5.1 5.1H6.6c-3.67 0-5.1-1.43-5.1-5.1v-3.3c0-3.67 1.43-5.1 5.1-5.1Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M9.5 12.62c0-1.2.85-1.69 1.89-1.09l1.61.93c1.04.6 1.04 1.58 0 2.18l-1.61.93c-1.04.6-1.89.11-1.89-1.09v-1.86Z"
    />
  </svg>
)
export default SeriesIcon
